import api from "../../axiosConfig"; // ajustează path-ul corect

export async function authFetch(path, options = {}) {
  const method = (options.method || "GET").toUpperCase();

  const cfg = {
    headers: options.headers,
    responseType: options.responseType, // "blob" etc.
  };

  // body
  let body = options.body;
  if (typeof body === "string") {
    try {
      body = JSON.parse(body);
    } catch {
      /* leave as string */
    }
  }

  try {
    let res;
    if (method === "GET") res = await api.get(path, cfg);
    else if (method === "POST") res = await api.post(path, body, cfg);
    else if (method === "PUT") res = await api.put(path, body, cfg);
    else if (method === "PATCH") res = await api.patch(path, body, cfg);
    else if (method === "DELETE") res = await api.delete(path, cfg);
    else throw new Error(`Unsupported method: ${method}`);

    return options.responseType === "blob" ? res.data : res.data;
  } catch (err) {
    console.error("AXIOS ERROR FULL:", err);
    console.error("STATUS:", err?.response?.status);
    console.error("DATA:", err?.response?.data);
    throw new Error(
      (typeof err?.response?.data === "string"
        ? err.response.data
        : err?.response?.data?.message
          ? err.response.data.message
          : err?.response?.data?.detail
            ? (typeof err.response.data.detail === "string"
              ? err.response.data.detail
              : JSON.stringify(err.response.data.detail))
            : err?.response?.data
              ? JSON.stringify(err.response.data)
              : err.message) || "Internal Server Error",
    );
  }
}
